import { RiskClass } from 'app/shared/models/risk-class.enums'
import { User } from 'app/shared/models/user.model';

/**
 * Model to capture Client details.
 */
export class Client {
    id: number;
    riskScore: number;
    riskClass: RiskClass;
    startOfServices: Date | null;
    endOfServices: Date | null;
    status: number;
    statusName: String;
    statusDate: Date;
    reviewDate: Date;
    incorporationDate: Date;
    accountManagerVO = new User();
    financeManagerVO = new User();
    riskTimeIntervals: Map<String, Number>;
    serviceValues: Array<Object>;
    systemDivision: Object;
    isWTT: boolean;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/client.model.ts